import React, { Component } from 'react';
import { Grid, Form, Button, Segment, Header, Message, Image } from 'semantic-ui-react';
import { loginEmail, loadConfig, loadHoldList, forgotPassword } from '../utils/rest';
import * as consts from '../static/constants';
import Loading from '../ui/Loading';
import { withRouter } from 'react-router-dom';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      showError: false,
      errorMsg: this.props.t("incorrect.login"),
      loading: false,
      open: false,
      showErrorColor: "red"
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  close = () => {
    this.setState({
      open: false
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { history } = this.props;
    if (this.state.email !== "") {
      this.setState({
        loading: true
      });
      loginEmail(this.state.email)
        .then(response => {
          if (response != null) {
            history.push({
              pathname: '/password',
              search: '',
              state: { email: response }
            })
          } else {
            this.setState({
              showError: true,
              loading: false,
              showErrorColor: "red"
            });
          }
        }).catch(error => {
          if (error !== null && typeof error.response !== 'undefined') {
            if(error.response.status == 308){
              caches.keys().then((names) => {
                names.forEach(name => {
                    caches.delete(name);
                })
                window.location.replace(error.response.data)
              });
            }else{
              this.setState({
                errorMsg: error.response.data,
                showError: true,
                loading: false,
                showErrorColor: "red"
              })
            }
          } else {
            this.setState({
              errorMsg: this.props.t("timeout"),
              showError: true,
              loading: false,
              showErrorColor: "red"
            });
          }
        });
    }
  }

  handleResetPasswordLink = (e) => {
    e.preventDefault();
    if (this.state.email.length > 0) {
      forgotPassword({}, {
        user: this.state.email
      }).then(response => {
        if (response !== null) {
          this.setState({
            errorMsg: response,
            showError: true,
            loading: false,
            showErrorColor: "green"
          });
        }
      });
    } else {
      this.setState({
        errorMsg: this.props.t("username.required"),
        showError: true,
        loading: false,
        showErrorColor: "red"
      });
    }
  }

  componentDidMount() {

    this.loadConfigOnce();

    let paramsString = window.location.search;
    if (paramsString.length > 0) {
      const params = new URLSearchParams(paramsString);
      const token = params.get('token');

      if(token){
        localStorage.setItem(consts.ACCESS_TOKEN, token);
        this.props.history.push("/home");
      }else{
        const r = params.get('r');
        this.setState({
          errorMsg: r === "login" ? this.props.t("new.credentials") : r === "expired" ? this.props.t("expired") : r === "texpired" ? this.props.t("texpired") : r,
          showError: true,
          loading: false,
          showErrorColor: "red"
        });
      }
      }
    }

  loadConfigOnce = () => {
    //if (Object.keys(this.props.config).length === 0) {
    loadConfig().then((response) => {
      this.props.addToConfig(response);
      localStorage.setItem("config", JSON.stringify(response));
    });
    let holdReason = [];
    loadHoldList().then((response) => {
      if (response != null) {
        let hold = Object.keys(response);
        hold.map((item, index) => {
          holdReason.push({
            key: index + 1, text: item, value: item
          });
          return item;
        })
      }
      this.props.addItem("holdReason", holdReason);
    });
    //}
  }

  render() {
    let showError;
    if (this.state.showError) {
      showError = (
        <Message className="small" color={this.state.showErrorColor}>
          {this.state.errorMsg}
        </Message>
      );
    }
    if (this.state.loading) {
      return (
        <Loading />
      )
    }
    return (
      <div>
        <Grid className="center aligned" >
          <Grid.Column width={5} />
          <Grid.Column width={6} style={{ marginTop: "150px" }}>
            <Header as="h2" className="login-version" >
              <div className="content">
                <Image style={{ maxHeight: 100, maxWidth: 300 }} src={(this.props.config.LOGIN_LOGO ? this.props.config.LOGIN_LOGO : "")} alt="" />
                {this.props.t("app.name")}
                <span className="version-txt"> {this.props.config.version} </span>
              </div>
            </Header>
            <Form className="large">
              <Segment>
                <Form.Input icon='user' required={true} iconPosition='left' type="text" name="email" placeholder={this.props.t("email")} onChange={this.onChange} value={this.state.email} />
                <Button type="submit" onClick={this.handleSubmit} size="large" className="fluid grey">Next</Button>
                <p className="textright link"><a onClick={this.handleResetPasswordLink}>{this.props.t("forgot.password")}</a></p>
              </Segment>
            </Form>
            {showError}
            <Message className="small">
              {this.props.t("need.help")} <a href="" dangerouslySetInnerHTML={{ __html: this.props.config.AGENCY_SUPPORT_NUMBER }}></a><br />
              {this.props.config.LOGIN_TEXT}
            </Message>
          </Grid.Column>
          <Grid.Column width={5} />
        </Grid>
      </div>
    );
  }
}
export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/app/login/Login.js